var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 0C6.51509 0 5.53982 0.193993 4.62987 0.570904C3.71993 0.947814 2.89314 1.50026 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5C0 10.815 2.1525 13.6275 5.13 14.625C5.505 14.685 5.625 14.4525 5.625 14.25V12.9825C3.5475 13.4325 3.105 11.9775 3.105 11.9775C2.76 11.1075 2.2725 10.875 2.2725 10.875C1.59 10.41 2.325 10.425 2.325 10.425C3.075 10.4775 3.4725 11.1975 3.4725 11.1975C4.125 12.3375 5.2275 12 5.655 11.82C5.7225 11.3325 5.9175 11.0025 6.1275 10.815C4.4625 10.6275 2.715 9.9825 2.715 7.125C2.715 6.2925 3 5.625 3.4875 5.0925C3.4125 4.905 3.15 4.125 3.5625 3.1125C3.5625 3.1125 4.1925 2.91 5.625 3.8775C6.2175 3.7125 6.8625 3.63 7.5 3.63C8.1375 3.63 8.7825 3.7125 9.375 3.8775C10.8075 2.91 11.4375 3.1125 11.4375 3.1125C11.85 4.125 11.5875 4.905 11.5125 5.0925C12 5.625 12.285 6.2925 12.285 7.125C12.285 9.99 10.53 10.62 8.8575 10.8075C9.1275 11.04 9.375 11.4975 9.375 12.195V14.25C9.375 14.4525 9.495 14.6925 9.8775 14.625C12.855 13.62 15 10.815 15 7.5C15 6.51509 14.806 5.53982 14.4291 4.62987C14.0522 3.71993 13.4997 2.89314 12.8033 2.1967C12.1069 1.50026 11.2801 0.947814 10.3701 0.570904C9.46018 0.193993 8.48491 0 7.5 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github_icon.f733ba06ce49abf98a934aa9650d21ed.svg";
export { ForwardRef as ReactComponent };